import React, { useState } from 'react';
import { forgotPasswordService } from '../../service/forgotpassword.service';
import { Button, Form } from 'react-bootstrap';
import Input from 'react-select/dist/declarations/src/components/Input';
import { InputText } from 'primereact/inputtext';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await forgotPasswordService.forgotPassword(email);
      setSubmitted(true);
    } catch (error) {
      setMessage('Failed to send reset link.');
    }
  };

  return (
    <div className="content">
      <div className="content-body p-0">
        <div className="login-bg">
          <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
            {!submitted ? (
              <div className="d-flex justify-content-end w-100">
                <form className="login-form" onSubmit={handleSubmit}>
                  <div className="d-flex flex-column gap-2">
                    <h2 className="login-title">Forgot your password?</h2>

                    <div className="d-flex flex-column gap-2 form-group">
                      <label htmlFor="email">Email ID</label>
                      <InputText
                        type="email"
                        id="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    <Button type="submit" className="p-button-primary">
                      Reset Password
                    </Button>

                    {message && (
                      <div className="alert alert-info mt-2 text-center" role="alert">
                        {message}
                      </div>
                    )}

                    <div className="text-center mt-3">
                      <span>Remember your password? </span>
                      <a href="/login" className="text-link" style={{ color: "#1976d2" }}>
                        Back to login
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="card shadow-lg border-0 rounded-4 p-4 text-center" style={{ maxWidth: '450px', width: '100%' }}>
                <div className="card-body">
                  <i className="bi bi-envelope-check-fill text-success" style={{ fontSize: '3rem' }}></i>
                  <h4 className="mt-3">Check your email</h4>
                  <p className="text-muted">We've sent a password reset link to <strong>{email}</strong>.</p>
                  <a href="/login" className="btn btn-primary mt-3">Back to Login</a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>


  );
};

export default ForgotPasswordPage;
